
const custom_text = {
    field_type: 'input',
    key: 'text',
    element: {
        placeholder: 'e.g. resume, paper, slides, PDF, eBook',
    },
}
const upload = {
    field_type: 'input',
    key: 'url',
    element: {
        type: 'file',
        show_label_before: true,
        validator(value) {
            if (! this.related_model.get('url')) return 'Please upload a file.'
        },
    },
}
const buttonset = {
    field_type: 'buttonset',
    buttons: [
        {
            type: 'submit',
            label: 'Save',
            loading_label: 'Saving…',
            className: 'button fullwidth dark primary xlarge',
        },
    ],
}


const download_list = [
    {
        id: 'download_paper',
        label: 'Download my paper',
        glyph: 'page',
        fields: [upload, buttonset],
    },
    {
        id: 'read_resume',
        label: 'Read my resume',
        glyph: 'page-text',
        fields: [upload, buttonset],
    },
    {
        id: 'download_my_blank',
        label: 'Download my…',
        glyph: 'download-arrow',
        fields: [custom_text, upload, buttonset],
    },
    {
        id: 'read_my_blank',
        label: 'Read my…',
        glyph: 'book-open',
        fields: [custom_text, upload, buttonset],
    },
    {
        id: 'get_a_copy_of_my_blank',
        label: 'Get a copy of my…',
        glyph: 'pages',
        fields: [custom_text, upload, buttonset],
    },
]

// assign common properties
download_list.forEach(spotlight => {
    spotlight.is_premium = true
    spotlight.mechanism = 'download'
    spotlight.group = 'download'
})

module.exports = download_list
